import { get, values } from 'lodash'

export const getMenus = state => values(get(state, ['menus', 'byId']))
